import { render, staticRenderFns } from "./BtnVoltarEtapaContrato.vue?vue&type=template&id=d239255a"
import script from "./BtnVoltarEtapaContrato.vue?vue&type=script&lang=js"
export * from "./BtnVoltarEtapaContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports